import React from 'react';
import PropTypes from 'prop-types';
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export default function ServicesTableToolbar({
  local, archive, onAddClick, onSetArchive,
}) {
  return (
    <GridToolbarContainer>
      <Button
        variant="text"
        size="small"
        color={archive ? 'primary' : 'secondary'}
        onClick={() => onSetArchive(!archive)}
      >
        {local.archive}
      </Button>
      { !archive && (
        <Button
          variant="text"
          size="small"
          color="primary"
          onClick={onAddClick}
        >
          {local.add}
        </Button>
      )}
      <Box sx={{ flexGrow: 1 }} />
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport csvOptions={{ delimiter: ';', utf8WithBom: true }} />
    </GridToolbarContainer>
  );
}

ServicesTableToolbar.propTypes = {
  local: PropTypes.shape({
    add: PropTypes.string,
    archive: PropTypes.string,
  }).isRequired,
  archive: PropTypes.bool,
  city: PropTypes.shape({}),
  onAddClick: PropTypes.func.isRequired,
  onSetArchive: PropTypes.func.isRequired,
};

ServicesTableToolbar.defaultProps = {
  archive: false,
  city: undefined,
};
